export function adaptParams(params) {
    const p = {};
    Object.entries(params).forEach(([k, v]) => {
        if (Array.isArray(v))
            p[k] = v.join();
        else
            p[k] = v;
    });
    return p;
}
//# sourceMappingURL=utils.js.map